var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nuxt-link',{staticClass:"header-logo",style:(_vm.styles),attrs:{"aria-label":"adidas","to":_vm.localePath(_vm.mainPageUrl)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }